export const replaceBaseUrlAndLang = (routeData: string, url: string, language: string) => {
  return routeData?.replace('{baseUrl}', url).replace('{lang}', language)
}
